/* eslint-disable react-hooks/exhaustive-deps */
import _ from 'lodash';
import React, { useEffect, useState } from 'react';

const Index = ({
  label,
  source,
  default: defaultValue,
  path,
  mask,
  defaultValuePath,
}) => {
  const [value, setValue] = useState(defaultValue);

  useEffect(() => {
    const defaultValueFromPath = _.get(source, defaultValuePath, defaultValue);

    const sourceValue = _.get(
      source,
      path,
      defaultValuePath ? defaultValueFromPath : defaultValue,
    );
    if (mask && sourceValue !== defaultValue) {
      setValue(mask.replace('<{value}>', sourceValue));
    } else {
      setValue(sourceValue);
    }
  }, [defaultValue, mask, path, source]);

  return (
    <tr>
      <td>
        <h5>{label}</h5>
      </td>
      <td>
        <p>{value}</p>
      </td>
    </tr>
  );
};

const ItemDetailTable = React.memo(Index);

export default ItemDetailTable;
